import { useTranslation } from 'react-i18next';
import ImageBox from '../ImageBox';
import { UserImageComponent } from './UserImageComponent';
import { useChatUI } from '~/context/chatUI';

function ImageAttachment({ attachment, index }: { attachment: any; index: number }) {
  const { t } = useTranslation('chat');
  const { mode } = useChatUI();

  const Component = mode === 'public' ? UserImageComponent : ImageBox;

  const imageId = attachment.imageId != null ? String(attachment.imageId) : undefined;

  return (
    <Component
      src={attachment.url}
      alt={attachment.name || t('image.image-number', { number: index + 1 })}
      imageId={imageId}
      isAttachment={true}
      reversed
    />
  );
}

export default ImageAttachment;
